import { OnInit, OnDestroy } from '@angular/core';
import {
  UserService,
  CampusWard,
  CampusStake,
  MessageDialog
} from '../shared';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

/**
 * Base class for all of our components that are for leaders or admins proxied as a leader.
 */
export abstract class LeaderComponent implements OnInit, OnDestroy {
  private proxyWard: CampusWard = null;
  private proxyStake: CampusStake = null;
  private wardSubscription: Subscription;
  private stakeSubscription: Subscription;

  constructor(
    protected userService: UserService,
    protected dialog: MatDialog
  ) {}

  ngOnInit() {
    this.wardSubscription = this.userService.proxyWard.subscribe(
      ward => (this.proxyWard = ward)
    );
    this.stakeSubscription = this.userService.proxyStake.subscribe(
      stake => (this.proxyStake = stake)
    );

    // TODO figure out how to handle the lds account folks
  }

  ngOnDestroy() {
    if (this.wardSubscription) {
      this.wardSubscription.unsubscribe();
    }

    if (this.stakeSubscription) {
      this.stakeSubscription.unsubscribe();
    }
  }

  /**
   * Whether or not the user is proxying for a ward or stake.
   */
  isProxying() {
    return this.proxyStake != null || this.proxyWard != null;
  }

  /**
   * Returns whether or not the person logged in is a Leader of a Campus Stake OR if the person logged in is an Admin that is
   * proxying for a Campus Stake unit.
   */
  isStakeLeader(): boolean {
    // TODO figure out how to handle lds account
    return this.proxyStake != null;
  }

  /**
   * Returns whether or not the person logged in is a Leader of a Campus Ward OR if the person logged in is an Admin that is
   * proxying for a Campus Ward unit.
   */
  isWardLeader(): boolean {
    // TODO figure out how to handle lds account
    return this.proxyWard != null;
  }

  /**
   * Gets the stake that the user is a leader of or is proxying for.
   */
  getStake(): CampusStake {
    // TODO figure out how to handle lds account
    return this.proxyStake;
  }

  /**
   * Gets the ward that the user is a leader of or is proxying for.
   */
  getWard(): CampusWard {
    // TODO figure out how to handle lds account
    return this.proxyWard;
  }

  /**
   * Tells you if the given form control has the given validation error.
   */
  hasError(formControl: FormControl, error: string): boolean {
    return (
      (formControl.touched || formControl.dirty) && formControl.hasError(error)
    );
  }

  /**
   * Shows an error dialog to the user.
   */
  protected showError(message: string) {
    this.dialog.open(MessageDialog, {
      data: { message: message, isError: true }
    });
  }
}
